import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { Product } from "./components/Product";

export const App = (props) => {
    let interval;

    const [products, setProducts] = useState([]);
    const [levels, setLevels] = useState(undefined);
    const [styleContainer, setstyleContainer] = useState(undefined);
    const [layout, setLayout] = useState([]);

    useEffect(() => {
        // Get token
        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let token = params.token;

        if (token === null) {
            token = process.env.REACT_APP_STORE_ID;

            if (token === null) return;
        }

        const requestOptions = {
            method: "GET",
            headers: { "x-auth-token": token, "Content-Type": "application/json" },
        };

        Promise.all([fetch(`${process.env.REACT_APP_SERVER_URL}/products`, requestOptions), fetch(`${process.env.REACT_APP_SERVER_URL}/configuration`, requestOptions),])
            .then((allResponses) => {
                if (allResponses[0].status === 200 && allResponses[1].status === 200)
                    Promise.all([allResponses[0].json(), allResponses[1].json()])
                        .then((allJson) => {
                            // Products
                            let prod = allJson[0].map((p) => {
                                let auxProd = {
                                    productId: p.productId, productName: p.productName, shelflifeTimer: p.shelflifeTimer, image: p.image, position: p.position,
                                    status: "disable"
                                };

                                if (p.skipLevel !== null) auxProd.skipLevel = p.skipLevel;

                                return auxProd;
                            })

                            // Configurations
                            const configuration = allJson[1]

                            let rowHeight = 0
                            let colWidth = 0
                            if (process.env.REACT_APP_ENVIRONMENT === "development") {
                                rowHeight = process.env.REACT_APP_SCREEN_HEIGHT / process.env.REACT_APP_NUMBER_ROWS
                                colWidth = process.env.REACT_APP_SCREEN_WIDTH / process.env.REACT_APP_NUMBER_COLS
                            } else {
                                rowHeight = configuration.height / configuration.numberOfRows
                                colWidth = configuration.width / configuration.numberOfCols
                            }

                            document.documentElement.style.setProperty("--var-row-height", rowHeight + "px")

                            let layoutCols = [];
                            for (let col = 1; col <= configuration.numberOfCols; col++)
                                layoutCols.push(col);

                            let layoutRows = [];
                            for (let row = 0; row <= configuration.numberOfRows; row++) {
                                layoutRows.push(
                                    <Row key={row} className="row-height" style={{ margin: 0 }}>
                                        {layoutCols.map(col =>
                                            <Col key={row * 100 + col} style={{ padding: 0, maxWidth: colWidth + "%" }}>
                                                {prod.find(f => f.position === (row * parseInt(allJson[1].numberOfCols) + col)) !== undefined ?
                                                    <Product product={prod.find(f => f.position === (row * parseInt(allJson[1].numberOfCols) + col))}
                                                        levels={configuration.levels}
                                                        response={handleProductResponse} />
                                                    : null}
                                            </Col>
                                        )}
                                    </Row>
                                )
                            }

                            // style for DEV environment
                            if (process.env.REACT_APP_ENVIRONMENT === "development") {
                                setstyleContainer({
                                    padding: 0, overflowY: "hidden", backgroundColor: "white", paddingTop: 2 + "px",
                                    width: process.env.REACT_APP_SCREEN_WIDTH + "px", minWidth: process.env.REACT_APP_SCREEN_WIDTH + "px",
                                    height: process.env.REACT_APP_SCREEN_HEIGHT + "px", minHeight: process.env.REACT_APP_SCREEN_HEIGHT + "px",
                                });
                            } else {
                                setstyleContainer({ padding: 0, maxWidth: 100 + "%", paddingTop: 2 + "px", overflowY: "hidden" });
                            }

                            setProducts(prod)
                            setLayout(layoutRows)
                            setLevels(configuration.levels)
                        })
                        .catch();
            })
            .catch();
    }, []);

    const handleProductResponse = (product) => {
        if (products.length === 0)
            return;

        const productId = product.split(";")[0];
        const status = product.split(";")[1];

        let prod = products;
        const index = prod.findIndex((f) => f.productId === productId);
        prod[index].status = status === "enable";

        clearInterval(interval);
        setProducts(prod);
    };

    if (levels === undefined || styleContainer === undefined || layout.length === 0)
        return (
            <div>
                <h1 style={{ color: "white" }}>Sem produtos selecionados</h1>
            </div>
        );

    return (
        <Container style={styleContainer}>
            {layout}
        </Container>
    );
};
